import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c6744d1&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1c6744d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6744d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6744d1')) {
      api.createRecord('1c6744d1', component.options)
    } else {
      api.reload('1c6744d1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1c6744d1&scoped=true&", function () {
      api.rerender('1c6744d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/assets/tokenCard/index.vue"
export default component.exports